import {useEffect} from 'react'
import {showUpgradeModal} from '../../Modals/UpgradeModal.js'

import {
  BYOA_SHIPPERS,
  ORDORO_SHIPPERS,
  PITNEY,
  UPS,
} from '../../../common/constants/ShipperNames.js'
import {NEW_ID} from '../../../common/constants/index.js'
import Forms from './Forms/index.js'
import {useSelector} from '../../../store.js'
import {
  useBYOAShippersSelector,
  useOrdoroShippersSelector,
} from '../../../data/company.js'
import {
  newShipperOptionsSelector,
  settingsShippersNewSelector,
  shippersFormSelector,
  updateShippersForm,
} from './ShippersFunctions.js'
import className from '../../../common/className.js'
import Icon from '../../../common/icons/Icon.js'

export default function NewForm() {
  const {newVendor} = useSelector(shippersFormSelector)
  const isAdding = useSelector(settingsShippersNewSelector)
  const useOrdoroShippers = useSelector(useOrdoroShippersSelector)
  const useBYOAShippers = useSelector(useBYOAShippersSelector)
  const newShipperOptions = useSelector(newShipperOptionsSelector)

  const formName = `settings__shippers__new_${newVendor}`

  const Form = Forms[newVendor]
  const isExpanded = isAdding

  let isFeatureLockedOrdoroShipper =
    !useOrdoroShippers && ORDORO_SHIPPERS.includes(newVendor)
  const isFeatureLockedBYOAShipper =
    !useBYOAShippers && BYOA_SHIPPERS.includes(newVendor)

  // if both are off then UPS can't be used
  // so pick a feature lock to show
  if (!useOrdoroShippers && !useBYOAShippers && newVendor === UPS) {
    isFeatureLockedOrdoroShipper = true
  }

  useEffect(() => {
    if (!isExpanded) {
      return
    }

    let firstShipper = newShipperOptions.find(
      (option) => option.value === PITNEY,
    )

    if (!firstShipper) {
      firstShipper = newShipperOptions[0] || {}
    }

    if (firstShipper.value) {
      updateShippersForm({newVendor: firstShipper.value})
    }
  }, [isExpanded, newShipperOptions])

  return (
    <li
      className={className`list__item--settings-wrap list__item--add-item-wrap clearfix ${{expanded: isExpanded}}`}
    >
      <div className="medium-12 columns button-wrap">
        <p>
          <a
            href={`#/settings/shipper/${NEW_ID}`}
            title="Add a shipper"
            className="inline-text-button no-underline"
          >
            <Icon name="sym-add" className="fs-01 margin-right-5" />
            <span>Add a shipper</span>
          </a>
        </p>
      </div>
      {isExpanded && (
        <div className="settings-list-item-form-wrap padding-top-5 clear-both">
          <fieldset>
            <ul className="form-list margin-bottom-0 margin-left-15">
              {newShipperOptions.length ? (
                <li className="form-list-item margin-bottom-0">
                  <label htmlFor="shipper_type" className="margin-bottom-5">
                    Select your shipper:
                  </label>
                  <select
                    className="select bigger-select margin-bottom-0"
                    id="shipper_type"
                    value={newVendor}
                    onChange={(event) =>
                      updateShippersForm({newVendor: event.target.value})
                    }
                  >
                    {newShipperOptions.map(({value, display}) => (
                      <option key={value} value={value}>
                        {display}
                      </option>
                    ))}
                  </select>
                </li>
              ) : (
                <li className="form-list-item margin-bottom-0">
                  No carriers are available to add
                </li>
              )}
            </ul>
            {newVendor && (
              <div className="list__title-logo margin-left-15 margin-top-15">
                <div className={className`wrap--logo ${newVendor}`} />
              </div>
            )}
            {isFeatureLockedOrdoroShipper ? (
              <div className="alert alert--lg alert--warning-lt margin-top-25 margin-bottom-0 align-center w-65">
                <Icon
                  name="lock-closed"
                  className="fs-04 op-30 lh-sm margin-bottom-0"
                />
                <p className="align-center fs-02 lh-md  margin-bottom-15">
                  <strong>
                    Ready to connect a carrier so you can create shipping
                    labels?
                  </strong>
                </p>
                <p className="fs-01 margin-bottom-20">
                  To gain access to this feature, you need to enable our
                  Shipping App.
                </p>
                <div className="margin-bottom-10">
                  <button
                    className="btn btn--primary btn--primary-alt btn--md fs-01"
                    onClick={() => showUpgradeModal()}
                  >
                    <strong>Manage Your Apps</strong>
                  </button>
                </div>
              </div>
            ) : isFeatureLockedBYOAShipper ? (
              <div className="alert alert--lg alert--warning-lt margin-top-25 margin-bottom-0 align-center w-65">
                <Icon
                  name="lock-closed"
                  className="fs-04 op-30 lh-sm margin-bottom-0"
                />
                <p className="align-center fs-02 lh-md  margin-bottom-15">
                  <strong>
                    Ready to bring your own shipping carrier account on board?
                  </strong>
                </p>
                <p className="fs-01 margin-bottom-20">
                  In order to do this, you need to be on the Premium plan of the
                  Shipping App.
                </p>
                <div className="margin-bottom-10">
                  <button
                    className="btn btn--primary btn--primary-alt btn--md fs-01"
                    onClick={() => showUpgradeModal()}
                  >
                    <strong>Upgrade Your Plan</strong>
                  </button>
                </div>
              </div>
            ) : Form ? (
              <Form formName={formName} />
            ) : null}
          </fieldset>
        </div>
      )}
    </li>
  )
}
